import React from "react";
import styled from "styled-components";
import pic3 from "./ASSESTS/Food/hero.png";
import { Link } from "react-router-dom";

const Display: React.FC = () => {
  return (
    <div>
      <Container>
        <Wrapper>
          <Hold>
            <Texts>
              <h4>ENJOY QUALITY SERVICE</h4>
              <h1>
                NEVER OUT OF STOCK,
                <span>Flavors and tastes galore</span>
              </h1>
              <p>
                Our service will make you feel at home. The most blissful
                experience you can ever expect.
                <span>You will not want to leave us at all</span>
              </p>
            <Link style={{textDecoration:"none"}} to="/product">
            <button >SHOP NOW</button>
            </Link>
            </Texts>
          </Hold>
        </Wrapper>
      </Container>
    </div>
  );
};

export default Display;

const Hold = styled.div`
  display: flex;
  text-align: left;
  margin-left: 30px;
  z-index: 1111;
  width: 80%;
  @media screen and (max-width: 500px) {
    z-index: 111;
    width: 300px;
    height: 400px;
    background-color: #ffffff7a;
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
`;

const Texts = styled.div`
  z-index: 111;
  color: white;
  font-weight: 200;
  text-align: left;
  /* line-height: 1; */
  span {
    color: white;
    font-weight: 200;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50px;
    background-color: black;
    color: white;
    cursor: pointer;
    font-weight: bold;
    transition: all ease-in-out 400ms;
    margin-top: 20px;
    border-radius: 2px;
    border: 1px solid black;
    transition: all 400ms ease-in-out;
    :hover {
      background-color: #0000005c;
      transform: scale(0.99);
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 500px;
  background-color: white;

  background-image: url(${pic3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  backdrop-filter: blur(5px);
  position: relative;
  ::before {
    content: "";
    width: 100%;
    height: 100%;
    background-color: #00000083;
    position: absolute;
    backdrop-filter: blur(5px);
  }
`;
